'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconBellAndComment, iconBellAndCommentTag } from '@ni/nimble-components/dist/esm/icons/bell-and-comment';
import { wrap } from '../../utilities/react-wrapper';

export type { IconBellAndComment };
export { iconBellAndCommentTag };
export const NimbleIconBellAndComment = wrap(IconBellAndComment);